import { render, staticRenderFns } from "./communication-channels.vue?vue&type=template&id=60b696fe&scoped=true"
import script from "./communication-channels.vue?vue&type=script&lang=js"
export * from "./communication-channels.vue?vue&type=script&lang=js"
import style0 from "./communication-channels.vue?vue&type=style&index=0&id=60b696fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b696fe",
  null
  
)

export default component.exports